import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store/store";
import { Paginator } from "primereact/paginator";
import {
  formatDate,
  initialrows,
  messages,
  paginationRows,
} from "../../api/constants";
import { Toast } from "primereact/toast";
import {
  getvmataccount,
  getVmatAccountTotals,
  updatevmataccount,
} from "../../store/slice/vmataccount";
import CustomButtonComponent from "../../components/button/CustomButtonComponent";
import { InputTextarea } from "primereact/inputtextarea";

const VmatAccount = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useRef<Toast>(null);
  const searchQuery = useSelector((state: any) => state.search);
  const [data, setData]: any = useState([]);
  const [selectedRowId, setSelectedRowId]: any = useState(null);
  const [backupData, setBackupData]: any = useState(null);
  const [totals, setTotals]: any = useState();
  // const [paymentData, setPaymentData]: any = useState({
  //   pending: 0,
  //   paid: 0,
  // });
  //pagination
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(initialrows);
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(0);
  const onPageChange = (event: any) => {
    setPage(event.page);
    setFirst(event.first);
    setRows(event.rows);
  };

  const onInputChange2 = (e: any, id: any, field: any) => {
    const { value } = e.target;
    const newData: any = data.map((row: any) => {
      if (row._id === id) {
        return { ...row, [field]: value };
      }
      return row;
    });
    setData(newData);
  };

  const renderInput2 = (rowData: any, field: any) => {
    return (
      <>
        {rowData._id !== selectedRowId ? (
          <span>{rowData[field.field] || ""}</span>
        ) : (
          <InputTextarea
            disabled={rowData._id !== selectedRowId}
            value={rowData[field.field] || ""}
            onChange={(e) => onInputChange2(e, rowData._id, field.field)}
            rows={1}
            cols={27}
            autoResize
          />
        )}
      </>
    );
  };

  const onInputChange = (e: any, id: any, field: any) => {
    const { value } = e.target;
    const newData: any = data.map((row: any) => {
      if (row._id === id) {
        if (field === "vmatexpense") {
          const updatedRow = { ...row, [field]: value };
          const result = updatedRow.vmatcrossing + updatedRow.vmatcommision;
          updatedRow.income = result;
          updatedRow.profit = result - Number(updatedRow.vmatexpense);
          return updatedRow;
        }
      }
      return row;
    });
    setData(newData);
  };

  const renderInput = (rowData: any, field: any) => {
    const isStringField = ["reason"].includes(field.field);
    return (
      <InputText
        disabled={rowData._id !== selectedRowId}
        value={rowData[field.field] || ""}
        onChange={(e) => onInputChange(e, rowData._id, field.field)}
        keyfilter={isStringField ? undefined : "num"}
        autoComplete="off"
      />
    );
  };

  const renderButton = (rowData: any) => {
    return (
      <CustomButtonComponent
        rowData={rowData}
        selectedRowId={selectedRowId}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
      />
    );
  };

  const handleSave = async (rowData: any) => {
    const payload = {
      vmatexpense: Number(rowData.vmatexpense),
      reason: rowData.reason,
      tdsdeduction: rowData.tdsdeduction,
      income: rowData.income,
      profit: rowData.profit,
      _id: rowData._id,
    };
    try {
      const response = await dispatch(updatevmataccount(payload));
      if (response.payload.data && !response.payload.error) {
        const index = backupData.findIndex(
          (item: any) => item._id === rowData._id
        );
        if (index !== -1) {
          // data[index]._id = response.payload.data._id;
          const updatedBackupData = backupData.map((item: any) =>
            item._id === rowData._id
              ? {
                  ...item,
                  vmatexpense: Number(response.payload.data.vmatexpense),
                  reason: response.payload.data.reason,
                  tdsdeduction: response.payload.data.tdsdeduction,
                  income: response.payload.data.income,
                  profit: response.payload.data.profit,
                  _id: response.payload.data._id,
                }
              : item
          );
          setBackupData(updatedBackupData);
          setData([...updatedBackupData]);
        }
        fetchTotals();
        setSelectedRowId(null);
        toast.current?.show({
          severity: "success",
          summary: messages.success,
          detail: messages.updateoraddsuccess,
          life: 3000,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: messages.error,
        detail: messages.updateoraddfailure,
        life: 3000,
      });
    }
  };

  const handleEdit = (rowData: any) => {
    // setSelectedRowId(rowData._id);
    // setBackupData([...data]);
    setBackupData(data);
    const filtered = data.filter((x: any) => x._id === rowData._id);
    setData(filtered);
    setSelectedRowId(rowData._id);
  };

  const handleCancel = () => {
    if (backupData) {
      setData(backupData);
      setBackupData(null);
    }
    setSelectedRowId(null);
  };
  // Compute totals for each column
  const computeTotal = () => {
    return (
      Number(totals?.totalIncome || 0) - Number(totals?.totalVmatExpense || 0)
    );
  };

  const fetchData = useCallback(async () => {
    try {
      const trcukData = await dispatch(
        getvmataccount({
          limit: rows,
          offset: page * rows,
          search: searchQuery,
        })
      );
      if (Array.isArray(trcukData.payload.data) && !trcukData.payload.error) {
        setData(trcukData.payload.data);
        setTotalPage(trcukData.payload.pagination.totalDocuments);
      }
      if (trcukData.payload.error) {
        toast.current?.show({
          severity: "error",
          summary: messages.error,
          detail: trcukData.payload.message || messages.loadfailure,
          life: 3000,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: messages.error,
        detail: messages.loadfailure,
        life: 3000,
      });
    }
  }, [dispatch, page, rows, searchQuery]);

  const fetchTotals = useCallback(async () => {
    try {
      const trcukData = await dispatch(
        getVmatAccountTotals({
          search: searchQuery,
        })
      );
      if (trcukData.payload.data && !trcukData.payload.error) {
        setTotals(trcukData.payload.data);
      }
      if (trcukData.payload.error) {
        toast.current?.show({
          severity: "error",
          summary: messages.error,
          detail: trcukData.payload.message || messages.loadfailure,
          life: 3000,
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: messages.error,
        detail: messages.loadfailure,
        life: 3000,
      });
    }
  }, [dispatch, searchQuery]);

  // const fetchCreditAndDebit = useCallback(async () => {
  //   try {
  //     const trcukData = await dispatch(getCreditAndDebit());
  //     if (trcukData.payload.data && !trcukData.payload.error) {
  //       const { truckTotal, ackTotal, transportTotal, transAdvanceTotal } =
  //         trcukData.payload.data;
  //       setPaymentData({
  //         pending: truckTotal + ackTotal,
  //         paid: transportTotal + transAdvanceTotal,
  //       });
  //     }
  //     if (trcukData.payload.error) {
  //       toast.current?.show({
  //         severity: "error",
  //         summary: messages.error,
  //         detail: trcukData.payload.message || messages.loadfailure,
  //         life: 3000,
  //       });
  //     }
  //   } catch (error) {
  //     toast.current?.show({
  //       severity: "error",
  //       summary: messages.error,
  //       detail: messages.loadfailure,
  //       life: 3000,
  //     });
  //   }
  // }, [dispatch]);

  useEffect(() => {
    const fetchDataAndLog = async () => {
      await fetchTotals();
      await fetchData();
      // await fetchCreditAndDebit();
    };
    fetchDataAndLog();
  }, [fetchData, fetchTotals]);

  return (
    <div className="p-2" style={{ overflowX: "auto" }}>
      <Toast ref={toast} />
      {/* <div className="flex my-3 ">
        <div className="flex justify-between items-center gap-3 w-full">
          <span className="text-sm font-bold text-red-500">{`Pending : ₹ ${paymentData.pending}`}</span>
          <span className="text-sm font-bold text-green-500">{`Paid : ₹ ${paymentData.paid}`}</span>
        </div>
      </div> */}
      <DataTable value={data} showGridlines scrollable scrollHeight="80vh">
        <Column
          field="ats.sno"
          header="S.No"
          style={{ minWidth: "100px" }}
        ></Column>
        <Column
          field="ats.date"
          header="Date"
          body={(rowData: any) => formatDate(rowData.ats.date)}
          style={{ minWidth: "100px" }}
        ></Column>
        <Column field="ats.transname" header="Transport Name"></Column>
        <Column field="ats.trucknumber" header="Truck Number"></Column>
        <Column
          field="vmatcommision"
          header="VMAT Commission"
          footer={totals?.totalVmatCommision || 0}
        ></Column>
        <Column
          field="vmatcrossing"
          header="VMAT Crossing"
          footer={totals?.totalVmatCrossing || 0}
        ></Column>
        <Column
          field="tdsdeduction"
          header="TDS Deduction"
          // body={renderInput}
          footer={totals?.totalTdsDeduction || 0}
        ></Column>
        <Column
          field="vmatexpense"
          header="Vmat Expense"
          body={(rowData: any, field: any) =>
            selectedRowId === rowData._id
              ? renderInput(rowData, field)
              : rowData.vmatexpense
          }
          footer={totals?.totalVmatExpense || 0}
        ></Column>
        <Column field="reason" header="Reason" body={renderInput2}></Column>
        <Column
          field="income"
          header="VMAT Income"
          footer={totals?.totalIncome || 0}
        ></Column>
        {/* <Column field="profit" header="VMAT Profit"></Column> */}
        <Column
          header="Actions"
          body={renderButton}
          style={{ minWidth: "200px", right: "0", position: "sticky" }}
          footer={
            <span className="text-red-500 font-bold text-sm">{`PROFIT : ${computeTotal()}`}</span>
          }
        ></Column>
      </DataTable>
      <Paginator
        first={first}
        rows={rows}
        totalRecords={totalPage}
        onPageChange={onPageChange}
        rowsPerPageOptions={paginationRows}
      />
    </div>
  );
};

export default VmatAccount;
